import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  cardNumberRange,
  facilityCodeRange,
  formatSelect,
  lastCardNumberValidation,
  lengthValidation60,
  onlyNumeric,
  required,
} from '../Forms/utils';

import { ACCESS_CARDS_TYPE_OPTIONS } from '../../staticData';
import { REACT_SELECT_INPUT, STYLED_TEXT } from '../Forms/fieldTypes';

const AccessCardBatchFormComponent = (props) => {
  const {
    form,
    onSubmit,
    onLoad,
    initialValues,
    isCreate,
    property,
    isLyazonType,
    selectedType,
  } = props;

  const formData = [
    {
      keyName: 'type',
      label: 'Type',
      fieldType: REACT_SELECT_INPUT,
      options: formatSelect(ACCESS_CARDS_TYPE_OPTIONS, 'label', 'value'),
      validate: [required],
    },
    {
      keyName: 'property',
      label: 'Property',
      fieldType: REACT_SELECT_INPUT,
      options: formatSelect(Object.values(property)),
      validate: [required],
      isHidden: !selectedType,
    },
    {
      keyName: 'name',
      label: 'Batch Name',
      fieldType: STYLED_TEXT,
      validate: [required],
      isHidden: !selectedType,
    },
    {
      keyName: 'facilityCode',
      label: 'Facility Code',
      fieldType: STYLED_TEXT,
      validate: isLyazonType ? [] : [required, onlyNumeric, facilityCodeRange],
      isHidden: !selectedType,
    },
    {
      keyName: 'cardNumbersList',
      fieldType: STYLED_TEXT,
      label: 'Card Number List (paste comma separated string)',
      multiline: true,
      validate: isLyazonType && isCreate ? [required] : [],
      isHidden: !selectedType || !isLyazonType || !isCreate,
    },
    {
      keyName: 'firstCardNumber',
      label: 'First Card Number',
      fieldType: STYLED_TEXT,
      validate: isLyazonType ? [] : [required, onlyNumeric, cardNumberRange],
      isHidden: !selectedType || isLyazonType,
    },
    {
      keyName: 'lastCardNumber',
      label: 'Last Card Number',
      fieldType: STYLED_TEXT,
      validate: isLyazonType
        ? []
        : [required, onlyNumeric, cardNumberRange, lastCardNumberValidation],
      isHidden: !selectedType || isLyazonType,
    },
    {
      keyName: 'cardNumberOffset',
      label: 'Card Number Offset',
      fieldType: STYLED_TEXT,
      validate: isLyazonType ? [] : [required, lengthValidation60],
      isHidden: !selectedType || isLyazonType,
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      title={`${isCreate ? 'Add' : 'Update'} Access Card Batch`}
      submitText={isCreate ? 'Create' : 'Update'}
      onLoad={onLoad}
      enableReinitialize
    />
  );
};

AccessCardBatchFormComponent.defaultProps = {
  property: {},
  selectedType: null,
};
AccessCardBatchFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onLoad: PropTypes.func.isRequired,
  isCreate: PropTypes.bool.isRequired,
  property: PropTypes.instanceOf(Object),
  isLyazonType: PropTypes.bool.isRequired,
  selectedType: PropTypes.string,
};

export default AccessCardBatchFormComponent;
